import React from "react";
import "./styles/Invoice.css";

export default function InvoiceTable({
  rows,
  handleChange,
  handleEdit,
  handleSave,
  handleCancel,
  deleteRow,
  addSubItem,
  handleSubChange,
  deleteSubItem
}) {

  // ✅ GRAND TOTAL (DYNAMIC)
  const grandTotal = rows.reduce((sum, r) => {

    const subTotal = (r.subItems || []).reduce(
      (s, item) => s + (item.total || 0),
      0
    );

    return sum + subTotal;

  }, 0);

  return (

    <table className="invoice-table">

      <thead>
        <tr>
          <th>Invoice #</th>
          <th>Customer</th>
          <th>Date</th>
          <th>Category</th>
          <th>Description</th>
          <th>Qty</th>
          <th>Amount</th>
          <th>Total</th>
          <th>Action</th>
        </tr>
      </thead>

      <tbody>

        {rows.length === 0 ? (

          <tr>
            <td colSpan="9">No data found</td>
          </tr>

        ) : (

          <>
            {rows.map(r => {

              const subItems = r.subItems || [];

              return (

                <React.Fragment key={r.id}>

                  {subItems.map((item, index) => (

                    <tr key={index}>

                      {/* ✅ SHOW ONLY ON FIRST ROW */}
                      {index === 0 && (
                        <>
                          <td rowSpan={subItems.length}>
                            {r.invoiceNo}
                          </td>

                          <td rowSpan={subItems.length}>
                            <input
                              type="text"
                              value={r.customerName ?? ""}
                              disabled={!r.isEditing}
                              onChange={e =>
                                handleChange(
                                  r.id,
                                  "customerName",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                        </>
                      )}

                      {/* ✅ DATE FOR EACH EXPENSE */}
                      <td>
                        <input
                          type="date"
                          value={item.date || ""}
                          disabled={!r.isEditing}
                          onChange={e =>
                            handleSubChange(
                              r.id,
                              index,
                              "date",
                              e.target.value
                            )
                          }
                        />
                      </td>

                      {/* ✅ CATEGORY */}
                      <td>
                        <select
                          value={item.category || ""}
                          disabled={!r.isEditing}
                          onChange={e =>
                            handleSubChange(
                              r.id,
                              index,
                              "category",
                              e.target.value
                            )
                          }
                        >
                          <option value="">Select</option>
                          <option>Travel</option>
                          <option>Hotel</option>
                          <option>Shopping</option>
                          <option>Billing</option>
                          <option>Others</option>
                        </select>
                      </td>

                      {/* ✅ DESCRIPTION */}
                      <td>
                        <input
                          value={item.description || ""}
                          disabled={!r.isEditing}
                          onChange={e =>
                            handleSubChange(
                              r.id,
                              index,
                              "description",
                              e.target.value
                            )
                          }
                        />
                      </td>

                      {/* ✅ QTY */}
                      <td>
                        <input
                          type="text"
                          value={item.quantity ?? ""}
                          disabled={!r.isEditing}
                          onChange={e =>
                            handleSubChange(
                              r.id,
                              index,
                              "quantity",
                              e.target.value
                            )
                          }
                        />
                      </td>

                      {/* ✅ AMOUNT */}
                      <td>
                        <input
                          type="text"
                          value={item.amount ?? ""}
                          disabled={!r.isEditing}
                          onChange={e =>
                            handleSubChange(
                              r.id,
                              index,
                              "amount",
                              e.target.value
                            )
                          }
                        />
                      </td>

                      {/* ✅ ITEM TOTAL */}
                      <td>
                        <b>{(item.total || 0).toFixed(2)}</b>
                      </td>

                      {/* ✅ ACTION */}
                      <td>

                        {r.isEditing ? (
                          <>
                            <button
                              onClick={() => handleSave(r.id)}
                            >
                              Save
                            </button>

                            <button
                              onClick={() => handleCancel(r.id)}
                            >
                              Cancel
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              onClick={() => handleEdit(r.id)}
                            >
                              Edit
                            </button>

                            <button
                              onClick={() =>
                                deleteSubItem(r.id, index)
                              }
                            >
                              Delete
                            </button>

                            <button
                              onClick={() => addSubItem(r.id)}
                            >
                              Add
                            </button>
                          </>
                        )}

                      </td>

                    </tr>

                  ))}

                </React.Fragment>

              );

            })}

            {/* ✅ GRAND TOTAL */}
            <tr>

              <td
                colSpan="7"
                style={{ textAlign: "right" }}
              >
                <b>Grand Total</b>
              </td>

              <td>
                <b>{grandTotal.toFixed(2)}</b>
              </td>

              <td></td>

            </tr>

          </>

        )}

      </tbody>

    </table>

  );
}